import { ws } from "../../../utils/common"

export const resetPasswordWS = async ({ id }) => {
    const res = await ws(
        "GET",
        process.env.REACT_APP_ENDPOINT + "reset-password/" + id,
        null,
        false
    );

    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
};
